export default "__VITE_ASSET__24cb4d84__"